import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaExternalLinkAlt, FaEnvelope } from "react-icons/fa";
import { companiesReferrals as companies } from "../../assets/constants";
import { Link } from "react-router-dom";

export default function ReferralsSlider() {
  const [visitedCompanies, setVisitedCompanies] = useState({});

  const handleVisit = (name, link) => {
    window.open(link, "_blank", "noopener,noreferrer");
    setVisitedCompanies((prev) => ({
      ...prev,
      [name]: true,
    }));
  };

  const handleReferral = (company) => {
    if (!visitedCompanies[company.name]) return; // ✅ Block clicks if disabled

    const subject = encodeURIComponent(`Referral Request for ${company.name}`);
    const body = encodeURIComponent(
      `Hi,\n\nI visited ${company.name}'s careers page and found a job I am interested in. Could you please refer me?\n\nJob Link: \n\nThanks,\n[Your Name]`
    );
    const cc = "codearenaui@gmail.com";
    window.location.href = `mailto:${company.email}?cc=${cc}&subject=${subject}&body=${body}`;
  };

  const loopedCompanies = [...companies, ...companies];

  return (
    <div className="bg-gray-50 py-12 overflow-hidden">
      <h2 className="text-center text-2xl sm:text-3xl font-extrabold text-gray-900 mb-8">
        💼 Find Matching Jobs & Request Referrals
      </h2>

      <div className="relative w-full">
        <motion.div
          className="flex gap-6 w-max"
          animate={{ x: ["0%", "-50%"] }}
          transition={{
            repeat: Infinity,
            duration: 20,
            ease: "linear",
          }}
        >
          {loopedCompanies.map((company, index) => {
            const isVisited = visitedCompanies[company.name];

            return (
              <div
                key={index}
                className="min-w-[200px] max-w-[220px] h-[260px] ca-card ca-card-hover overflow-hidden"
              >
                {/* Top Half - Logo */}
                <div className="h-1/2 w-full overflow-hidden">
                  <img
                    src={company.logo}
                    alt={company.name}
                    className="h-full w-full object-cover rounded-t-2xl"
                  />
                </div>

                {/* Bottom Half */}
                <div className="h-1/2 flex flex-col justify-center gap-2 p-3 bg-white">
                  <h3 className="text-base font-semibold text-gray-900 text-center">
                    {company.name}
                  </h3>

                  <button
                    onClick={() =>
                      handleVisit(company.name, company.careersLink)
                    }
                    className="flex items-center justify-center gap-2 px-3 py-1.5 text-xs rounded-lg bg-blue-50 text-blue-700 font-medium hover:bg-blue-100 transition-colors"
                  >
                    Careers <FaExternalLinkAlt className="text-[10px]" />
                  </button>

                  {company.email && (
                    <button
                      onClick={() => handleReferral(company)}
                      className={`flex items-center justify-center gap-2 px-3 py-1.5 text-xs rounded-lg font-medium transition-all ${
                        isVisited
                          ? "bg-green-600 text-white hover:bg-green-700"
                          : "bg-gray-200 text-gray-400 cursor-not-allowed"
                      }`}
                      disabled={!isVisited}
                    >
                      <FaEnvelope className="text-[10px]" />
                      Get Referred
                    </button>
                  )}

                  {company.url && (
                    <div
                      onClick={(e) => {
                        if (!isVisited) e.preventDefault();
                      }}
                    >
                      <Link
                        to={isVisited ? company.url : "#"}
                        target={isVisited ? "_blank" : "_self"}
                        className={`flex items-center justify-center gap-2 px-3 py-1.5 text-xs rounded-lg font-medium transition-all ${
                          isVisited
                            ? "bg-green-600 text-white hover:bg-green-700"
                            : "bg-gray-200 text-gray-400 cursor-not-allowed pointer-events-none"
                        }`}
                      >
                        <FaEnvelope className="text-[10px]" />
                        Get Referred
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </motion.div>
      </div>
    </div>
  );
}
